<script setup lang="ts">
import { ChevronDownIcon } from '@heroicons/vue/24/outline';
defineProps<{ open: boolean }>();
const emit = defineEmits<{
  (e: 'toggle'): void;
}>();
</script>

<template>
  <div
    :class="[
      'flex justify-center items-center h-fit',
      'bg-light-50 dark:bg-dark-800 px-3 py-4',
      'text-base text-base-color cursor-pointer',
      'md:hidden before:absolute',
      'before:content-[\' \'] before:z-10',
      'before:w-3 before:-translate-x-full',
      'before:pointer-events-none before:blur-[2px] dark:before:blur-[4px]',
      'before:bg-gradient-to-l before:from-dark-900/25 before:to-transparent',
      'dark:before:from-dark-900/80',
      {
        'h-full': !open,
        'h-fit right-0 absolute top-0 z-5 before:inset-y-0 before:left-0': open,
        'before:right-8 before:top-0 before:bottom-0': !open,
      },
    ]"
    @click="emit('toggle')"
  >
    <ChevronDownIcon
      class="w-5 stroke-3 transition-all duration-300"
      :class="{ '-rotate-180': open }"
    />
  </div>
</template>
